/**
 * Paging class used to retrieve correct page from the api when retrieving events
 */

export class Paging {
  constructor(public limit: number, public page: number) {}
}
